export default __webpack_public_path__ + "static/media/logo-white.b3ebf536.svg";